import { useTranslation } from 'react-i18next'
// Uses the hook

const Translator = ({ path, required }) => {
  const { t } = useTranslation() // Translation Function
  return t(path) + `${required ? ' *' : ''}`
}

export default Translator